import React, { useState, useEffect, useRef } from 'react';
import { checkMenu } from '../Utils/Common';
import DefaultLayout from '../component/DefaultLayout';
import Footer from '../component/Footer';
import Api from '../config/Api';
import { Link as LinkRouter } from 'react-router-dom';
import { AiOutlinePlus, AiFillEdit, AiFillDelete } from 'react-icons/ai'
// import Table from 'react-bootstrap/Table';
import Form from 'react-bootstrap/Form';
import FloatingLabel from 'react-bootstrap/FloatingLabel';
import InputGroup from 'react-bootstrap/InputGroup';
import Button from 'react-bootstrap/Button';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Breadcrumb from 'react-bootstrap/Breadcrumb';
import Card from 'react-bootstrap/Card';
import { AiOutlineRollback } from "react-icons/ai";
import { useHistory, useParams } from 'react-router-dom';
import Alert from 'react-bootstrap/Alert';
import { FiSearch } from "react-icons/fi";
import moment from 'moment'
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
// import InputMask from 'react-input-mask';
import { NumericFormat } from 'react-number-format';
import Select from 'react-select';
import AsyncSelect from 'react-select/async';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import {
  ClassicEditor,
  Bold,
  Essentials,
  Heading,
  Indent,
  IndentBlock,
  Italic,
  Link,
  List,
  MediaEmbed,
  Paragraph,
  Table,
  Undo
} from 'ckeditor5';
import 'ckeditor5/ckeditor5.css';
import dayjs from "dayjs";
import { RiSettings2Fill } from 'react-icons/ri';
import 'bootstrap/dist/css/bootstrap.min.css';
import { data } from 'jquery';
import { defaultConf } from "../config/DefaultConf";
import Modal from 'react-bootstrap/Modal';
import Stack from 'react-bootstrap/Stack';
import ReactPaginate from "react-paginate";

function Editbanner() {
  const {id} = useParams();
  const history = useHistory();
  const [pages, setPages] = useState([]);
  const [fontSizes, setFontSizes] = useState([]);
  const [fonts, setFonts] = useState([]);
  const [aligns, setAligns] = useState([]);
  const [buttons, setButtons] = useState([]);
  const [sections, setSections] = useState([]);
  const [details, setDetails] = useState({});
  const [error, setError] = useState(null);
  const [errorForm, setErrorForm] = useState([]);
  const [validated, setValidated] = useState(false);
  const [defaultSelectedTitleOpacity, setDefaultSelectedTitleOpacity] = useState(50);
  const [defaultSelectedDescriptionsOpacity, setDefaultSelectedDescriptionsOpacity] = useState(50);
  const [defaultSelectedButtonTitleOpacity, setDefaultSelectedButtonTitleOpacity] = useState(100);
  const [fileList, setFileList] = useState([])
  const [fullscreen, setFullscreen] = useState(true);
  const [pageFile, setPageFile] = useState(1);
  const [limitFile, setLimitFile] = useState(15);
  const [pagesFile, setPagesFile] = useState(0);
  const [rowsFile, setRowsFile] = useState(0);
  const [modalShow, setModalShow] = React.useState(false);
  const [selectedProject, setSelectedProject] = useState("");
  const [selectedType, setSelectedType] = useState("");
  const filePath = defaultConf.uploadUrl;

  const today = new Date();
  
  const [startDate, setStartDate] = useState(new Date());
  
  const [formData, setFormData] = useState({
    title: '',
    titleFontSize: '',
    titleFontColor: '',
    titleAlign: '',
    titleBackgroundColor: '',
    titlePosition: '',
    titleFontFamily: '',
    buttonTitle: '',
    buttonSize: '',
    buttonTitleFontSize: '',
    buttonTitleFontColor: '',
    buttonTitlePosition: '',
    buttonTitleBackgroundColor: '',
    descriptions: '',
    descriptionsFontSize: '',
    descriptionsFontColor: '',
    descriptionsPosition: '',
    descriptionsAlign: '',
    descriptionsBackgroundColor: '',
    descriptionsFontFamily: '',
    banner: '',
    targetUrl: '',
    titleBgOpacity: 50,
    buttonBgOpacity: 100,
    descriptionsBgOpacity: 50,
  });

  const editorDescRef = useRef();
  const editorContentRef = useRef();

  const defaultFonts = [
    {
      fontName: 'Arial',
      selected: false,
    },
    {
      fontName: 'Helvetica',
      selected: false,
    },
    {
      fontName: 'Times New Roman',
      selected: false,
    },
    {
      fontName: 'Courier New',
      selected: false,
    },
    {
      fontName: 'Verdana',
      selected: false,
    },
    {
      fontName: 'Tahoma',
      selected: false,
    },
    {
      fontName: 'Trebuchet MS',
      selected: false,
    },
    {
      fontName: 'Georgia',
      selected: false,
    },
    {
      fontName: 'Impact',
      selected: false,
    },
    {
      fontName: 'Comic Sans MS',
      selected: false,
    }
  ]


  const textAligns = [
    {
      align: 'left',
      selected: false,
    },
    {
      align: 'center',
      selected: false,
    },
    {
      align: 'right',
      selected: false,
    },
    {
      align: 'justify',
      selected: false,
    },
  ]

  const btnSizes = [
    {
      title: 'normal',
      value: 'md',
      selected: false,
    },
    {
      title: 'small',
      value: 'sm',
      selected: false,
    },
    {
      title: 'large',
      value: 'lg',
      selected: false,
    },
  ]

  useEffect(() => {
    getDetails(id);
  }, []);


  const getDetails = (id) => {
    Api().get(`banners/${id}`)
    .then((response) => response)
    .then((detailsResponse) => {
      console.log(detailsResponse)
      if( detailsResponse.status === 200 )
      {
        const dataDetails = {
          title: detailsResponse.data.title || "",
          titleFontSize: detailsResponse.data.titleFontSize || "",
          titleFontColor: detailsResponse.data.titleFontColor || "",
          titleAlign: detailsResponse.data.titleAlign || "",
          titleBackgroundColor: detailsResponse.data.titleBackgroundColor === null ? "" : parseRgbaToHex(detailsResponse.data.titleBackgroundColor),
          titlePosition: detailsResponse.data.titlePosition || "",
          titleFontFamily: detailsResponse.data.titleFontFamily || "",
          buttonTitle: detailsResponse.data.buttonTitle || "",
          buttonSize: detailsResponse.data.buttonSize || "",
          buttonTitleFontSize: detailsResponse.data.buttonTitleFontSize || "",
          buttonTitleFontColor: detailsResponse.data.buttonTitleFontColor || "",
          buttonTitlePosition: detailsResponse.data.buttonTitlePosition || "",
          buttonTitleBackgroundColor: detailsResponse.data.buttonTitleBackgroundColor === null ? "" : parseRgbaToHex(detailsResponse.data.buttonTitleBackgroundColor),
          descriptions: detailsResponse.data.descriptions || "",
          descriptionsFontSize: detailsResponse.data.descriptionsFontSize || "",
          descriptionsFontColor: detailsResponse.data.descriptionsFontColor || "",
          descriptionsPosition: detailsResponse.data.descriptionsPosition || "",
          descriptionsAlign: detailsResponse.data.descriptionsAlign || "",
          descriptionsBackgroundColor: detailsResponse.data.descriptionsBackgroundColor === null ? "" : parseRgbaToHex(detailsResponse.data.descriptionsBackgroundColor),
          descriptionsFontFamily: detailsResponse.data.descriptionsFontFamily || "",
          banner: detailsResponse.data.banner._id || "",
          targetUrl: detailsResponse.data.targetUrl || "",
          titleBgOpacity: detailsResponse.data.titleBackgroundColor === null ? "" : getOpacity(detailsResponse.data.titleBackgroundColor)*100,
          buttonBgOpacity: detailsResponse.data.buttonTitleBackgroundColor === null ? "" : getOpacity(detailsResponse.data.buttonTitleBackgroundColor)*100,
          descriptionsBgOpacity: detailsResponse.data.descriptionsBackgroundColor === null ? "" : getOpacity(detailsResponse.data.descriptionsBackgroundColor)*100,
        }
        console.log(dataDetails)
        setFormData(dataDetails)
        setFormData({...formData, ['descriptions']: detailsResponse.data.descriptions || ""})

        console.log(parseRgbaToHex(detailsResponse.data.titleBackgroundColor))
        console.log(getOpacity(detailsResponse.data.titleBackgroundColor))

        setDefaultSelectedTitleOpacity(detailsResponse.data.titleBackgroundColor === null ? "" : getOpacity(detailsResponse.data.titleBackgroundColor)*100)
        setDefaultSelectedButtonTitleOpacity(detailsResponse.data.buttonTitleBackgroundColor === null ? "" : getOpacity(detailsResponse.data.buttonTitleBackgroundColor)*100)
        setDefaultSelectedDescriptionsOpacity(detailsResponse.data.descriptionsBackgroundColor === null ? "" : getOpacity(detailsResponse.data.descriptionsBackgroundColor)*100)

        getFontSize(6, 70, detailsResponse.data.titleFontSize);
        getFonts(detailsResponse.data.titleFontFamily)
        getAligns(detailsResponse.data.titleAlign)
        getButtons(detailsResponse.data.buttonSize)

        
        setDetails(detailsResponse.data)
      }
    })
    .catch((err) => {
    });
  }

  const getFontSize = async (minSize, maxSize, selectedFontSize) => {
    const sizes = [];
    console.log(selectedFontSize)
    for(let i=minSize; i<=maxSize; i++)
    {
      const size = {
        fontSize: i+'px',
        selected: false,
      }
      if( i+'px' === selectedFontSize )
      {
        // size.selected = true;
      }
      sizes.push(size)
    }
    console.log(sizes)
    setFontSizes(sizes)
  }

  const getFonts = async (selectedFont) => {
    try {
      console.log(selectedFont)
      const mapFonts = defaultFonts.map(font => ({
        ...font,
        // selected: selectedFont === font.fontName ? true : false,
      }))
      console.log(mapFonts)
      setFonts(mapFonts);
    } catch (err) {
      console.error(err);
    }
  }

  const getAligns = async (selectedAlign) => {
    try {
      console.log(selectedAlign)
      const mapAligns = textAligns.map(align => ({
        ...align,
        // selected: selectedAlign === align.align ? true : false,
      }))
      console.log(mapAligns)
      setAligns(mapAligns);
    } catch (err) {
      console.error(err);
    }
  }

  const getButtons = async (selectedBtn) => {
    try {
      const mapButtons = btnSizes.map(btn => ({
        ...btn,
        selected: selectedBtn === btn.value ? true : false,
      }))
      console.log(mapButtons)
      setButtons(mapButtons);
    } catch (err) {
      console.error(err);
    }
  }

  const onChangeEditorDesc = (e) => {
    setFormData({...formData, ['descriptions']: e})
  }

  const onChangeEditorContent = (e) => {
    setFormData({...formData, ['contents']: e})
  }

  const handleChange = (e) => {
    console.log(e)
    const key = e.target.name;
    const value = e.target.value;
    console.log(value)
    setFormData({...formData, [key]: value})
  }

  const handleChangeSelect = (e) => {
    const key = e.target.name;
    const value = e.target.value;
    setFormData({...formData, [key]: value})
  }
  
  const handleChangeSelectColor = (e) => {
    const key = e.target.name;
    const value = e.target.value;
    console.log(key)
    console.log(value)
    if( key === 'titleFontColor' || key === 'buttonTitleFontColor' || key === 'descriptionsFontColor' )
    {
      setFormData({...formData, [key]: value})
      console.log(value)
    }
    else
    {
      var opacity = 0;
      if( key === 'titleBackgroundColor')
      {
        opacity = formData.titleBgOpacity;
      }
      else if( key === 'buttonTitleBackgroundColor' )
      {
        opacity = formData.buttonBgOpacity;
      }
      else
      {
        opacity = formData.descriptionsBgOpacity;
      }
      setFormData({...formData, [key]: hexToRgba(value, opacity/100)})
      console.log(hexToRgba(value, opacity/100))
    }
  }
  
  const handleSubmit = (req) => {
    req.preventDefault();
    const form = req.currentTarget;
    if (form.checkValidity() === false) {
      req.preventDefault();
      req.stopPropagation();
      return;
    }

    setValidated(true);
    var data = new FormData(form);
    let formObject = Object.fromEntries(data.entries());
    formObject.titleBackgroundColor = hexToRgba(formObject.titleBackgroundColor, formObject.titleBgOpacity/100)
    formObject.buttonTitleBackgroundColor = hexToRgba(formObject.buttonTitleBackgroundColor, formObject.buttonBgOpacity/100)
    formObject.descriptions = formData.descriptions
    formObject.descriptionsBackgroundColor = hexToRgba(formObject.descriptionsBackgroundColor, formObject.descriptionsBgOpacity/100)
    
    console.log(formObject)
    Api().patch(`banners/${id}`, formObject)
    .then((response) => response)
    .then((data) => {
      if( data.status === 200 || data.status === 201){
        history.push('/banners');
      }
    })
    .catch((err) => {
    });
  };

  const hexToRgba = (hex, alpha) => {
    let cleanHex = hex.replace('#', '');

    if (cleanHex.length === 3) {
      cleanHex = cleanHex.split('').map(char => char + char).join('');
    }
    const r = parseInt(cleanHex.substring(0, 2), 16);
    const g = parseInt(cleanHex.substring(2, 4), 16);
    const b = parseInt(cleanHex.substring(4, 6), 16);

    return `rgba(${r}, ${g}, ${b}, ${alpha})`;
  };

  const parseRgbaToHex = (rgbaStr) => {
    console.log(rgbaStr)
    const match = rgbaStr.match(/rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*([\d.]+))?\)/)
    
    if (!match) return '#000000'

    const r = parseInt(match[1], 10)
    const g = parseInt(match[2], 10)
    const b = parseInt(match[3], 10)
    // Default to 1 (fully opaque) if alpha channel is missing
    const a = match[4] !== undefined ? match[4] : 1 

    const toHex = (val) => val.toString(16).padStart(2, '0')
    const alphaHex = Math.round(a * 255).toString(16).padStart(2, '0')

    // return `#${toHex(r)}${toHex(g)}${toHex(b)}${alphaHex}`.toUpperCase()
    return `#${toHex(r)}${toHex(g)}${toHex(b)}`.toUpperCase()
  }

  const getOpacityFromHex = (rgbaString) => {
    const match = rgbaString.match(/rgba?\((\d+),\s*(\d+),\s*(\d+),\s*([\d.]+)\)/);
    const opacity = 0;
    if (match) {
       opacity = parseFloat(match[4]); 
      console.log(opacity);
    }
      return opacity;
  }

  function getOpacity(rgba) {
    const match = rgba.match(/rgba?\(\s*\d+\s*,\s*\d+\s*,\s*\d+\s*,\s*([0-9.]+)\s*\)/);
    return match ? parseFloat(match[1]) : 1;
  }
    
  const getFileList = async (pageNum=pageFile, limitNum=limitFile) => {
    await Api().get(`files?page=${pageNum}&limit=${limitNum}`)
    .then((response) => response)
    .then((responseFiles) => {
      console.log(responseFiles)
      const listFiles = responseFiles.data;
      setFileList(listFiles.docs);
      setPageFile(listFiles.page);
      setPagesFile(listFiles.totalPages);
      setRowsFile(listFiles.totalDocs);
      setModalShow(true)
    })
    .catch((err) => {
    })
  }

  const changePageFile = ({ selected }) => {
    console.log(selected)
    setFileList([])
    setPageFile(selected+1);
    getFileList(selected+1);
  }

  
  
  const handleSetImage = async (e) => {
    // e.preventDefault();
    const idBanner = e.target.attributes.getNamedItem("data-id").value
    const type = e.target.attributes.getNamedItem("data-type").value
    setFormData({...formData, ['banner']: idBanner})

    const payload = {
      type: "Banner",
      banner: idBanner,
    };

    await Api().put(`files/cover/${selectedProject}`, payload)
    .then((response) => response)
    .then((res) => {
      console.log(res)
      if( res.status === 200 ){
        getDetails(id);
        setModalShow(false)
      }
    })
    .catch((err) => {
        
    });
  }
  
  const handleOpenFiles = async (e) => {
    e.preventDefault();
    const id = e.target.attributes.getNamedItem("data-id").value
    const type = e.target.attributes.getNamedItem("data-type").value
    setSelectedType(type)
    setSelectedProject(id)
    setFullscreen(true)
    getFileList()
  }

  const handleCloseModal = () => {
    setModalShow(false)
    setPageFile(1);
    setPagesFile(0);
    setRowsFile(0);
  }
    
  return (
    <>
      <div style={{ display: 'flex', height: '100%', direction: 'ltr' }}>
        <DefaultLayout />
        {/* <div className={ getStyles().collapsed === true ? 'content-wrapper collapsed' : 'content-wrapper' }> */}
        <main>
          <div className="content-header">
            <Container fluid>
              <Row className="">
                <Col sm={4}>
                  <h1 className="m-0">Edit Banner</h1>
                </Col>
                <Col sm={2}>
                  { checkMenu('contents') &&
                    <LinkRouter to="/banners"><Button variant="outline-primary" className="btn-upload"><AiOutlineRollback /> Back</Button></LinkRouter>
                  }
                </Col>
                <Col sm={3}>
                </Col>
                <Col sm={3}>
                  <div className="date-time float-sm-right">
                      { moment().format('dddd, DD MMMM YYYY') }
                  </div>
                </Col>
              </Row>
            </Container>
          </div>
              
          <div className="content">
            <Container fluid>
              <Row>
                <Col lg={12}>
                  <Card className="content-list">
                    <Card.Body>
                      <Col md="12">
                        <Form noValidate validated={validated} onSubmit={handleSubmit}>
                          <Row className="mb-3">
                            <Form.Group as={Col} md="12" controlId="validationCustom02">
                              <Form.Label>Title</Form.Label>
                              <Form.Control
                                required
                                type="textarea"
                                name="title"
                                defaultValue={details.title || formData.title}
                                onChange={handleChange}
                              />
                            </Form.Group>
                          </Row>
                          <Row className="mb-3">
                            <Form.Group as={Col} md="4" controlId="validationCustom08">
                              <Form.Label>Title Font Size</Form.Label>
                              <Form.Control
                                required
                                as="select"
                                name="titleFontSize"
                                defaultValue={details.titleFontSize || formData.titleFontSize}
                                onChange={handleChangeSelect}
                              >
                                <option value="">Select Font Size</option>
                                {
                                  fontSizes.map((item, i) => (
                                    <option key={i} value={item.fontSize} selected={item.fontSize === details.titleFontSize ? true : false}>{item.fontSize}</option>
                                  ))
                                }
                              </Form.Control>
                            </Form.Group>
                          </Row> 
                          <Row className="mb-3">
                            <Form.Group as={Col} md="12" controlId="validationCustom08">
                              <Form.Label>Title Font Color</Form.Label>
                              <Form.Control
                                type="color"
                                name="titleFontColor"
                                defaultValue={details.titleFontColor || formData.titleFontColor || "#ffffff"}
                                // defaultValue={defaultSelectedFontColor}
                                onChange={handleChangeSelectColor}
                              />
                            </Form.Group>
                          </Row>
                          <Row className="mb-3">
                            <Form.Group as={Col} md="4" controlId="validationCustom08">
                              <Form.Label>Title Font Family</Form.Label>
                              <Form.Control
                                required
                                as="select"
                                name="titleFontFamily"
                                defaultValue={details.titleFontFamily || formData.titleFontFamily}
                                onChange={handleChangeSelect}
                              >
                                <option value="">Select Font Family</option>
                                {
                                  fonts.map((item, i) => (
                                    <option key={i} value={item.fontName} selected={item.fontName === details.titleFontFamily ? true : false}>{item.fontName}</option>
                                  ))
                                }
                              </Form.Control>
                            </Form.Group>
                          </Row>
                          <Row className="mb-3">
                            <Form.Group as={Col} md="4" controlId="validationCustom08">
                              <Form.Label>Title Align</Form.Label>
                              <Form.Control
                                required
                                as="select"
                                name="titleAlign"
                                defaultValue={details.titleAlign || formData.titleAlign}
                                onChange={handleChangeSelect}
                              >
                                <option value="">Select Align</option>
                                {
                                  aligns.map((item, i) => (
                                    <option key={i} value={item.align} selected={item.align === details.titleAlign ? true : false}>{item.align}</option>
                                  ))
                                }
                              </Form.Control>
                            </Form.Group>
                          </Row>
                          <Row className="mb-3">
                            <Form.Group as={Col} md="3" controlId="validationCustom08">
                              <Form.Label>Title Background Color</Form.Label>
                              <Form.Control
                                type="color"
                                name="titleBackgroundColor"
                                defaultValue={details.titleBackgroundColor || formData.titleBackgroundColor || "#000000"}
                                // defaultValue={defaultSelectedFontColor}
                                onChange={handleChangeSelectColor}
                              />
                            </Form.Group><Form.Group as={Col} md="6" controlId="validationCustom08">
                              <Form.Label>Opacity</Form.Label>
                              <Form.Range 
                                name="titleBgOpacity"
                                defaultValue={formData.titleBgOpacity}
                                onChange={handleChange}
                              />
                            </Form.Group>
                          </Row>
                          <Row className="mb-3">
                            <Form.Group as={Col} md="4" controlId="validationCustom02">
                              <Form.Label>Button Title</Form.Label>
                              <Form.Control
                                // required
                                type="text"
                                name="buttonTitle"
                                defaultValue={details.buttonTitle || formData.buttonTitle}
                                onChange={handleChange}
                              />
                            </Form.Group>
                          </Row>
                          <Row className="mb-3">
                            <Form.Group as={Col} md="4" controlId="validationCustom08">
                              <Form.Label>Button Size</Form.Label>
                              <Form.Control
                                // required
                                as="select"
                                name="buttonSize"
                                defaultValue={details.buttonSize || formData.buttonSize}
                                onChange={handleChangeSelect}
                              >
                                <option value="">Select Button Size</option>
                                {
                                  buttons.map((item, i) => (
                                    <option key={i} value={item.value} selected={item.value === details.buttonSize ? true : false}>{item.title}</option>
                                  ))
                                }
                              </Form.Control>
                            </Form.Group>
                          </Row>
                          <Row className="mb-3">
                            <Form.Group as={Col} md="4" controlId="validationCustom08">
                              <Form.Label>Button Title Font Size</Form.Label>
                              <Form.Control
                                // required
                                as="select"
                                name="buttonTitleFontSize"
                                defaultValue={details.buttonTitleFontSize || formData.buttonTitleFontSize}
                                onChange={handleChangeSelect}
                              >
                                <option value="">Select Button Title Font Size</option>
                                {
                                  fontSizes.map((item, i) => (
                                    <option key={i} value={item.fontSize} selected={item.fontSize === details.buttonTitleFontSize ? true : false}>{item.fontSize}</option>
                                  ))
                                }
                              </Form.Control>
                            </Form.Group>
                          </Row>
                          <Row className="mb-3">
                            <Form.Group as={Col} md="12" controlId="validationCustom08">
                              <Form.Label>Button Title Font Color</Form.Label>
                              <Form.Control
                                type="color"
                                name="buttonTitleFontColor"
                                defaultValue={details.buttonTitleFontColor || formData.buttonTitleFontColor || "#ffffff"}
                                // defaultValue={defaultSelectedFontColor}
                                onChange={handleChangeSelectColor}
                              />
                            </Form.Group>
                          </Row>
                          <Row className="mb-3">
                            <Form.Group as={Col} md="3" controlId="validationCustom08">
                              <Form.Label>Button Background Color</Form.Label>
                              <Form.Control
                                type="color"
                                name="buttonTitleBackgroundColor"
                                defaultValue={details.buttonTitleBackgroundColor || formData.buttonTitleBackgroundColor || "#000000"}
                                // defaultValue={defaultSelectedFontColor}
                                onChange={handleChangeSelectColor}
                              />
                            </Form.Group>
                            <Form.Group as={Col} md="6" controlId="validationCustom08">
                              <Form.Label>Opacity</Form.Label>
                              <Form.Range 
                                name="buttonBgOpacity"
                                defaultValue={formData.buttonBgOpacity}
                                onChange={handleChange}
                              />
                            </Form.Group>
                          </Row>

                          <Row className="mb-3">
                            <Form.Group as={Col} md="12" controlId="validationCustom03">
                              <Form.Label>Descriptions</Form.Label>
                              <CKEditor
                                editor={ ClassicEditor }
                                config={ {
                                  toolbar: [
                                    'undo', 'redo', '|',
                                    'heading', '|', 'bold', 'italic', '|',
                                    'link', 'insertTable', 'mediaEmbed', '|',
                                    'bulletedList', 'numberedList', 'indent', 'outdent'
                                  ],
                                  licenseKey: 'GPL',
                                  plugins: [
                                    Bold,
                                    Essentials,
                                    Heading,
                                    Indent,
                                    IndentBlock,
                                    Italic,
                                    Link,
                                    List,
                                    MediaEmbed,
                                    Paragraph,
                                    Table,
                                    Undo
                                  ],
                                  root: {
                                    initialData: details.descriptions || formData.descriptions,
                                    placeholder: '',
                                  },
                                } }
                                onReady={ (editor) => {
                                  editorDescRef.current = editor;
                                } }
                                data={ details.descriptions || formData.descriptions }
                                onChange={ () => {
                                  onChangeEditorDesc( editorDescRef.current?.getData() );
                                } }
                              />
                            </Form.Group>	
                            <input type='hidden' defaultValue={formData.descriptions} name="descriptions" />
                          </Row>
                          <Row className="mb-3">
                            <Form.Group as={Col} md="4" controlId="validationCustom08">
                              <Form.Label>Descriptions Font Size</Form.Label>
                              <Form.Control
                                // required
                                as="select"
                                name="descriptionsFontSize"
                                defaultValue={details.descriptionsFontSize || formData.descriptionsFontSize}
                                onChange={handleChangeSelect}
                              >
                                <option value="">Select Font Size</option>
                                {
                                  fontSizes.map((item, i) => (
                                    <option key={i} value={item.fontSize} selected={item.fontSize === details.descriptionsFontSize ? true : false}>{item.fontSize}</option>
                                  ))
                                }
                              </Form.Control>
                            </Form.Group>
                          </Row> 
                          <Row className="mb-3">
                            <Form.Group as={Col} md="12" controlId="validationCustom08">
                              <Form.Label>Descriptions Font Color</Form.Label>
                              <Form.Control
                                type="color"
                                name="descriptionsFontColor"
                                defaultValue={details.descriptionsFontColor || formData.descriptionsFontColor || "#ffffff"}
                                // defaultValue={defaultSelectedFontColor}
                                onChange={handleChangeSelectColor}
                              />
                            </Form.Group>
                          </Row>
                          <Row className="mb-3">
                            <Form.Group as={Col} md="4" controlId="validationCustom08">
                              <Form.Label>Descriptions Font Family</Form.Label>
                              <Form.Control
                                // required
                                as="select"
                                name="descriptionsFontFamily"
                                defaultValue={details.descriptionsFontFamily || formData.descriptionsFontFamily}
                                onChange={handleChangeSelect}
                              >
                                <option value="">Select Font Family</option>
                                {
                                  fonts.map((item, i) => (
                                    <option key={i} value={item.fontName} selected={item.fontName === details.descriptionsFontFamily ? true : false}>{item.fontName}</option>
                                  ))
                                }
                              </Form.Control>
                            </Form.Group>
                          </Row>
                          <Row className="mb-3">
                            <Form.Group as={Col} md="4" controlId="validationCustom08">
                              <Form.Label>Descriptions Align</Form.Label>
                              <Form.Control
                                // required
                                as="select"
                                name="descriptionsAlign"
                                defaultValue={details.descriptionsAlign || formData.descriptionsAlign}
                                onChange={handleChangeSelect}
                              >
                                <option value="">Select Align</option>
                                {
                                  aligns.map((item, i) => (
                                    <option key={i} value={item.align} selected={item.align === details.descriptionsAlign ? true : false}>{item.align}</option>
                                  ))
                                }
                              </Form.Control>
                            </Form.Group>
                          </Row>
                          <Row className="mb-3">
                            <Form.Group as={Col} md="3" controlId="validationCustom08">
                              <Form.Label>Descriptions Background Color</Form.Label>
                              <Form.Control
                                type="color"
                                name="descriptionsBackgroundColor"
                                defaultValue={details.descriptionsBackgroundColor || formData.descriptionsBackgroundColor || "#000000"}
                                // defaultValue={defaultSelectedFontColor}
                                onChange={handleChangeSelectColor}
                              />
                            </Form.Group><Form.Group as={Col} md="6" controlId="validationCustom08">
                              <Form.Label>Opacity</Form.Label>
                              <Form.Range 
                                name="descriptionsBgOpacity"
                                defaultValue={formData.descriptionsBgOpacity}
                                onChange={handleChange}
                              />
                            </Form.Group>
                          </Row>
                          <Row className="mb-3">
                            <Form.Group as={Col} md="4" controlId="validationCustom08">
                              <Form.Label>Banner</Form.Label><br />
                              {details.banner !== null &&
                                <>
                                  <img src={filePath + details.banner?.uploadFile} width={300}/><br /><br />
                                </>
                              }
                              <input type="hidden" name="banner" defaultValue={details.banner?._id || formData.banner} />
                              <Button type="button" onClick={handleOpenFiles} data-id={details._id} data-type="Banner">{details.banner === null ? "Select Banner" : "Change Banner"}</Button>
                            </Form.Group>
                          </Row>
                          
                          <Row className="mb-3">
                            <Form.Group as={Col} md="12" controlId="validationCustom02">
                              <Form.Label>Target URL</Form.Label>
                              <Form.Control
                                // required
                                type="text"
                                name="targetUrl"
                                defaultValue={details.targetUrl || formData.targetUrl}
                                onChange={handleChange}
                              />
                            </Form.Group>
                          </Row>
                          {error && 
                            <Alert variant="danger">
                              {error}
                            </Alert>
                          }
                          <Button type="submit">Save</Button>
                        </Form>
                      </Col>
                    </Card.Body>
                  </Card>
                </Col>
              </Row>
            </Container>
          </div>
        </main>
      </div>
      <Footer />
      <Modal 
        show={modalShow} 
        fullscreen={fullscreen} 
        onHide={handleCloseModal}
        dialogClassName="modal-full-custom"
        scrollable={fullscreen}
      >
        <Modal.Header closeButton>
          <Modal.Title className='text-center'>
            Set Home Banner
          </Modal.Title>
        </Modal.Header>
        {/* <Modal.Header style={{display: "block"}}>
        </Modal.Header> */}
        <Modal.Body>
          <Container fluid>
            <Row xs={5} md={5} lg={5} className="g-2">
              {
                fileList.map((item, i) => (
                  <Col key={i}>
                    <Card>
                      <Card.Img variant="top" src={filePath + item.uploadFile} />
                      
                      <Card.Body>
                        <Button variant="primary" data-id={item._id} data-type={ selectedType === "Banner" ? "Banner" : "Thumbnails" } onClick={handleSetImage}>Choose This</Button>
                      </Card.Body>
                    </Card>
                  </Col>
                ))
              }
            </Row>
          </Container>
          
        </Modal.Body>
        <Modal.Footer>
          <Container fluid>
            <Row>
              <Col lg={3} md={4}>
                <p>Total Data: {rowsFile} Page: {rowsFile ? pageFile : 0} of {pagesFile}</p>
              </Col>
              <Col lg={9} md={8}>
                <nav
                  className="pagination float-sm-right"
                  key={rowsFile}
                  role="navigation"
                  aria-label="pagination"
                >
                  <ReactPaginate
                    previousLabel={"< Prev"}
                    nextLabel={"Next >"}
                    pageCount={pagesFile}
                    onPageChange={changePageFile}
                    containerClassName={"pagination-list pagination"}
                    pageLinkClassName={"pagination-link page-link"}
                    previousLinkClassName={"pagination-previous page-link"}
                    nextLinkClassName={"pagination-next page-link"}
                    activeLinkClassName={"pagination-link is-current"}
                    disabledLinkClassName={"pagination-link is-disabled"}
                    activeClassName={"active"}
                    pageClassName={"page-item"}
                  />
                </nav>
              </Col>
            </Row>
          </Container>
        </Modal.Footer>
      </Modal>
    </>
  )
}
export default Editbanner